export default __webpack_public_path__ + "images/517c05214a9e8de2fad545b1a29402e6.svg";